var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { addAccount } from '@popup/steem/actions/account.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { Screen } from 'src/reference-data/screen.enum';
const AddByAuth = ({ setErrorMessage, navigateTo, localAccounts, addAccount, setTitleContainerProperties, }) => {
    const [username, setUsername] = useState('');
    const [authorizedAccount, setAuthorizedAccount] = useState('');
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_setup',
            isBackButtonEnabled: true,
        });
    }, []);
    const submitForm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (localAccounts
            .map((localAccount) => localAccount.name)
            .includes(username)) {
            setErrorMessage('popup_html_account_already_existing');
            return;
        }
        try {
            const keys = yield AccountUtils.addAuthorizedAccount(username.trim(), authorizedAccount.trim(), localAccounts);
            if (keys && KeysUtils.keysCount(keys) >= 2) {
                addAccount({ name: username, keys: keys });
                navigateTo(Screen.SETTINGS_MAIN_PAGE);
            }
        }
        catch (err) {
            setErrorMessage(err.message, err.messageParams);
        }
    });
    return (React.createElement("div", { "data-testid": `${Screen.ACCOUNT_PAGE_ADD_BY_AUTH}-page`, className: "add-by-auth-page" },
        React.createElement("div", { className: "caption" }, getMessage('popup_html_auth_text')),
        React.createElement(InputComponent, { dataTestId: "input-username", value: username, onChange: setUsername, logo: SVGIcons.INPUT_AT, label: "popup_html_username", placeholder: "popup_html_username", type: InputType.TEXT, onEnterPress: submitForm }),
        React.createElement(InputComponent, { dataTestId: "input-authorized-account", value: authorizedAccount, onChange: setAuthorizedAccount, logo: SVGIcons.INPUT_AT, label: "popup_html_auth_placeholder_username_auth", placeholder: "popup_html_auth_placeholder_username_auth", type: InputType.TEXT, onEnterPress: submitForm }),
        React.createElement("div", { className: "fill-space" }),
        React.createElement(ButtonComponent, { dataTestId: "submit-button", label: 'popup_html_submit', onClick: submitForm })));
};
const mapStateToProps = (state) => {
    return {
        localAccounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    setErrorMessage,
    navigateTo,
    addAccount,
    setTitleContainerProperties,
});
export const AddByAuthComponent = connector(AddByAuth);
